module.exports = __webpack_public_path__ + "static/media/roomConfirmation.421d22f5.png";